export default {
    data:()=>({
        snackbarColor: 'error',
        snackbarValue: false,
        snackbarText: false,
    }),
    methods: {
        showSuccessSnackbar(text) {
            this.snackbarColor = 'success'
            this.snackbarText = text
            this.snackbarValue = true
        },
        showErrorSnackbar(text) {
            this.snackbarColor = 'error'
            this.snackbarText = text
            this.snackbarValue = true
        },
        showGeneralErrorSnackbar() {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('snackbar.messages.general_error')
            this.snackbarValue = true
        },
        hideSnackbar() {
            this.snackbarValue = false
        }
    }
}